window.option_pdf_viewer = {
    webgl: true,
    soundEnable: 0,
    soundFile: 'sound/dflip-sound.txt',
    pageMode: 1,
    allControls: "altPrev,pageNumber,altNext,outline,thumbnail,zoomIn,zoomOut,fullScreen,more,pageMode,startPage,endPage",
    paddingTop: 0,
    paddingLeft: 0,
    paddingRight: 0,
    paddingBottom: 0,
    singlePageMode: 2,
    shadowOpacity: 0,
    disableRange: true,
}